module.exports = __webpack_public_path__ + "static/media/tips-light-bulb.976b0aa0.svg";